import { Box, Button, Typography, useTheme } from '@mui/material'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'

import { useStyles } from '../styles'

interface IProps {
  actionText: string
  description: string
  buttonText: string
  disabled: boolean
  icon: JSX.Element
  handleClick: () => void
  actionSupText?: string
}

export const ActionItem = ({
  actionText,
  description,
  icon,
  disabled,
  buttonText,
  handleClick,
  actionSupText,
}: IProps) => {
  const theme = useTheme()
  const classes = useStyles()

  return (
    <div className={classes.actionCardContainer}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          {icon}
          <Typography
            variant="body2"
            align="center"
            color={theme.palette.custom.primary}
            fontWeight={700}
            sx={{
              position: 'relative',
              display: 'inline-block',
            }}
          >
            {actionText}
            {actionSupText && (
              <Typography
                sx={{
                  position: 'absolute',
                  top: '-2px',
                  right: '-29px',
                  fontStyle: 'italic',
                  fontSize: '8px',
                  fontWeight: 700,
                  color: theme.palette.custom.primary,
                }}
              >
                {actionSupText}
              </Typography>
            )}
          </Typography>
        </Box>
        <Typography
          fontWeight={600}
          color={theme.palette.custom.grey2}
          align="center"
          sx={{
            fontSize: '11px',
            pt: '20px',
            pb: '30px',
          }}
        >
          {description}
        </Typography>
      </Box>
      <Button
        sx={{
          fontSize: '14px',
          padding: '4px 16px',
          textTransform: 'none',
          borderRadius: '20px',
          minWidth: '150px',
        }}
        variant="contained"
        endIcon={<ArrowForwardIosIcon />}
        disabled={disabled}
        onClick={handleClick}
      >
        {buttonText}
      </Button>
    </div>
  )
}
